module.exports = __webpack_public_path__ + "static/media/PER.6eaf6c3b.svg";